// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CategoryProductList-ProductsMissing{padding:1rem;text-align:center}.CategoryProductList-More{min-height:3rem}.CategoryProductList-LoadButton{background-color:var(--category-product-list-load-button-background);cursor:pointer;font-size:13pt;margin-bottom:1rem;padding:1em 0;text-align:center}\n", ""]);
// Exports
module.exports = exports;
